import { useState, useCallback } from 'react';

export const useToggle = (initialState: boolean): [boolean, () => void] => {
  const [isEnabled, setValue] = useState<boolean>(initialState);
  const toggle = useCallback(() => setValue(!isEnabled), [isEnabled]);

  return [isEnabled, toggle];
};
